import React from 'react'
import PropTypes from 'prop-types'
import { getQueryString } from 'utils/queryString'
import { Field, formValueSelector } from 'redux-form'
import Card from 'forms/shared/fields/card'
import TextField from 'forms/shared/fields/text'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

const BillingFields = ({
  clientApplyCode,
  promoCode,
  promotionMessage,
  promotionValid,
  plan,
  place,
}) => {
  const history = useHistory()
  const invitationId = getQueryString(history.location.search).invitation_id

  return (
    <div className="my-5">
      <h2 className="text-2xl font-semibold">Payment</h2>
      <div className="my-3">
        <Field name="card" component={Card} />
      </div>
      <div className="my-5">
        <p className="text-lg font-semibold text-primary-orange mb-2">Promo code</p>
        <div className="flex justify-between">
          <Field
            type="input"
            name={`promo_code`}
            inputClassName={`border rounded-lg flex-1 p-2`}
            component={TextField}
          />
          <button
            type="button"
            className="btn-primary px-12 py-2 rounded-lg mx-5"
            onClick={() => clientApplyCode({ invitationId, promoCode, plan, place })}
          >
            Apply
          </button>
        </div>
        <div>
          <div className={`${promotionValid ? `text-green-500` : `text-red-500`}`}>
            {promotionMessage}
          </div>
        </div>
      </div>
    </div>
  )
}

BillingFields.propTypes = {
  clientApplyCode: PropTypes.func,
  promoCode: PropTypes.string,
  form: PropTypes.string,
  id: PropTypes.string,
  promotionMessage: PropTypes.string,
  promotionValid: PropTypes.bool,
  invitationId: PropTypes.string,
  plan: PropTypes.string,
  place: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  let selector
  const form = ownProps.form
  if (form) selector = formValueSelector(form)
  // eslint-disable-next-line camelcase
  const promotionDiscount = state.promocodes?.promo_discount
  const promotionMessage = promotionDiscount ? promotionDiscount.message : ''
  const promotionValid = promotionDiscount ? promotionDiscount.valid : false
  return {
    promoCode: selector ? selector(state, 'promo_code') : '',
    promotionValid,
    promotionMessage,
  }
}

export default connect(mapStateToProps, null)(BillingFields)
